import React, { useState, useEffect } from 'react';
import searchIcon from '../../../assets/search.svg';
import menu from '../../../assets/menu.svg';
import cart from '../../../assets/cart.svg';
import userSvg from '../../../assets/user.svg';
import { NavBar, Space, Image,Badge,Avatar,Tag } from 'antd-mobile';
import {  CloseOutline,ExclamationCircleFill } from 'antd-mobile-icons';
import { Popup, List } from 'antd-mobile';
import { connect, useHistory } from 'umi';
import styles from './index.less';
import logo from '../../../assets/headerlogo.svg';
import { queryCategoryListData,logout } from '@/api/service'
import SearchDialog from '@/components/searchDialog';
import { recommendTip } from '@/api/service'
import { NAEventType, sendRecord } from '../../../utils/aws_analytics.js';
import LiveTabBar from './tabbar'
import livinglogo from '@/assets/Logoliving.png'
const TopNavBar = (props: any) => {
  const { model,loginInfo,dispatch} = props;
  const [showpop, setShowpop] = useState(false);
  const [sub_showpop, setSub_showpop] = useState(false);
  const [categoriesList, setCategoriesList] = useState([]);
  const [searchState,setSearchState] = useState(false);
  // const [loginInfo, setLoginInfo] = useState<any>({});
  const everydayExtrasTip = localStorage.getItem('everydayExtrasTip')
  const history = useHistory();
  const queryCartUserInfo = async () => {
    dispatch({
      type: 'headInfo/getLoginInfoEffects',
    })
  }
  const getCategoryList = async () => {
    const data:any = await queryCategoryListData()
    if(data?.status == 'success'){
      setCategoriesList(data?.data)
    }
  }
  const gotoFavoritesList = () => {
    // history.push('/search')
    document.body.style.overflow = 'hidden';
    setSearchState(true)
  };
  const gotoLogin = (event:any) => {
    //阻止穿透
    event.stopPropagation();
    history.push('/cart');
  };
  const gotoUserPage = (event:any) => {
    //阻止穿透
    event.stopPropagation();
    if(loginInfo.login) {
      recommendTip()
      history.push('/account');
    }else{
      history.push('/login')
    }
    //setSub_showpop(true)
  }
  const clickCategroty = (item: any) => {
    console.log(item);
    setTimeout(() => {
      setShowpop(false)
    }, 300);
    let naContent = NAEventType.event.content;
    naContent.category = 'click menu';
    naContent.label = item.categoryName;
    sendRecord({ type: NAEventType.event.type, content: naContent });
    if(item.categoryName == 'Everyday Extras') {
      history.push('/everyday-extras')
      return
    }
    history.push(`/c/${item?.categoryName}?id=${item?.id}&tab=0`)
  };
  const signOut =async () => {
    const data:any =await logout()
    if(data.status == 'success'){
      window.location.reload()
    }
  }
  const clickUserManage = (id: any) => {
    if (id === 0) history.push('/account');
    if (id === 1) history.push('/buyagain');
    if (id === 2) history.push('/orders');
    if (id === 3) history.push('/addresses');
    if (id === 4) history.push('/payments');
    if (id === 5 && loginInfo.userImage) signOut();
    if (id === 5 && !loginInfo.userImage) history.push('/login');
  }
  
  const src:any = {
    modcart:logo,
    living:livinglogo
  }

  useEffect(()=>{
    if(dispatch){
      getCategoryList()
      queryCartUserInfo()
    }
  },[])
 
  let userManagementList = [
    {
      id: 0,
      text: 'My Profile',
    },
    {
      id: 1,
      text: 'Buy Again',
    },
    {
      id: 2,
      text: 'Placed Orders',
    },
    {
      id: 3,
      text: 'My Addresses',
    },
    {
      id: 4,
      text: 'Payment Options',
    },
    {
      id: 5,
      text: `${loginInfo.userImage?'Sign Out':'Sign In'}`,
    }
  ];
 
  
  return (
    <>
    {/* {
      history.location.pathname == '/' &&
      <LiveTabBar />
    } */}
      <NavBar
        className={styles.nav}
        backArrow={false}
        back={null}
        left={
          <Space className={styles.item_gap}>
            <div>
              <Image
                src={menu}
                className={styles.right_img}
                onClick={() => {
                  localStorage.setItem('everydayExtrasTip','clicked')
                  setSearchState(false)
                  setShowpop(true);
                }}
              />
              {!everydayExtrasTip&&
                <div className={styles.round}></div>
              }
            </div>
            <Image
              className={styles.right_img}
              src={searchIcon}
              onClick={gotoFavoritesList}
            />
          </Space>
        }
        right={
          <Space className={styles.item_gap}>
            <Badge 
            className='badge'
              color="#fff"
              style={{
                '--right': '-5px',
              }}
              content={loginInfo.cartNum == 0 || loginInfo.cartNum == ''?null:loginInfo.cartNum}
            >
              <Image
                className={styles.right_img}
                src={cart}
                onClick={(event)=>gotoLogin(event)}
              />
            </Badge>
            <div
              onClick={(event)=>gotoUserPage(event)}
              className={styles.nav_userImg}
            >
              {
                loginInfo.recommendTip &&
                <div className={styles.nav_warnbox}>
                  !
                </div>
              }
              {
                loginInfo.login?
                loginInfo.userImage?
                <Avatar src={loginInfo.userImage} 
                 className='ava'
                />:
                <div className='nameHead'>
                  {loginInfo.fullName?.split('')[0].toUpperCase()}
                </div>:<Image
                style={{
                  borderRadius: '50%',

                }}
                fit={'cover'}
                className={styles.right_img}
                src={ userSvg}            
              />
                
                
              }
              {/* <Image
                
                style={{
                  borderRadius: '50%',
                  width: '100%',
                  height: '100%',
                }}
                fit={'cover'}
                className={styles.right_img}
                src={loginInfo.userImage ? loginInfo.userImage : userSvg}            
              /> */}
            </div>
          </Space>
        }
      >
        <Image src={src[model]} className={styles.logo} onClick = {()=>history.push('/')}/>
      </NavBar>
      {searchState&&<SearchDialog setSearchState={setSearchState}/>}
      
      <Popup
        visible={showpop}
        onMaskClick={() => {
          setShowpop(false);
        }}
        position="left"
        className={styles.popup_left}
        // bodyStyle={{ width: '80vw' }}
      >
        <div style={{
          height: '100%',
          overflow:'scroll'
        }}>
          <List className={styles.menu_item}>
              {/* <List.Item
                className={styles.firstitem}
                style={{
                  fontFamily:'RobotoBold',
                  borderBottom: '1px solid black',
                }}
                key='all'
                
                extra={<CloseOutline 
                  className={styles.close_outline}
                  onClick={() => {
                  setShowpop(false);
                }}/>}
              >
                <Image src={src[model]} className={styles.menulogo} onClick = {()=>history.push('/')}/>
                <span
                  className={styles.firsttxt}
                >
                 All Categories
                </span>
              </List.Item> */}
              
            {categoriesList?.map((item:any) => (
              <List.Item
                key={item.id}
                onClick={() => {
                  clickCategroty(item);
                }}
              >
                <Space>
                  <Space>
                    {item.categoryName}
                  </Space>
                  {/* {
                    item.categoryName == 'Everyday Extras' &&
                  <Space><Tag className={styles.cus_tag} color='success'>NEW</Tag></Space>
                  } */}
                </Space>
              </List.Item>
            ))}
          </List>
        </div>
      </Popup>
      <Popup
        onMaskClick={() => {
          setSub_showpop(false);
        }}
        visible={sub_showpop}
        position="right"
        bodyStyle={{ width: '80vw' }}
      >
        <List className={styles.account_menu_item}>
            {userManagementList.map((item) => (
              <List.Item
                key={item.id}
                onClick={() => {
                  clickUserManage(item.id);
                }}
              >
                {item.text}
              </List.Item>
            ))}
          </List>
      </Popup>
    </>
  );
};
export default connect(({ headInfo }: any) => {
  return {
    ...headInfo
  };
})(TopNavBar);
